import { FieldAddonDropdown, FieldText, Icon } from '@dixa/lib-shared-habla';

type VariableInputProps = {
  /** Input value. */
  value: string;
  /** Variables to select from. */
  variables: string[];
  /** Handler that gets invoked when typing or selecting. */
  onChange: (variable: string) => void;
  /** Error message to display. */
  error?: string;
};

export const VariableInput = ({
  value,
  onChange,
  variables,
  error,
}: VariableInputProps): JSX.Element => {
  return (
    <FieldText
      label="Variable"
      placeholder="Add new name or select existing"
      meta={{ error }}
      input={{
        name: 'variable',
        value,
        onChange: (e) => onChange(e?.target?.value || ''),
      }}
      suffix={{
        type: 'custom',
        noWrap: true,
        value: (
          <FieldAddonDropdown
            noArrow
            fixed
            meta={{
              selectedValue: <Icon name="dropdown-list" />,
            }}
            items={variables.map((name) => ({
              id: name,
              name,
            }))}
            onSelect={({ id }) => onChange(id)}
          />
        ),
      }}
    />
  );
};
